import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { marked } from 'marked';


@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss']
})
export class ReleaseNotesComponent implements OnInit {
  markdownContent: string = '';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.loadMarkdownFile('assets/release-notes/RELEASE-NOTES.md');
  }

  loadMarkdownFile(filePath: string): void {
    this.http.get(filePath, { responseType: 'text' }).subscribe(
      (data) => {
        // Convert Markdown to HTML
        this.markdownContent = marked(data);
        let container = document.getElementById('markdown-container');
        container.innerHTML = this.markdownContent;
      },
      (error) => {
        console.error('Error loading markdown file:', error);
      }
    );
  }

  scrollToSection(event: Event, sectionId: string): void {
      event.preventDefault();  
  
      const targetElement = document.getElementById(sectionId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth', 
          block: 'start'
        });
      }
    }

}
